import { render } from "./fastFreeShippingModel.vue?vue&type=template&id=7a5ed90a"
import script from "./fastFreeShippingModel.vue?vue&type=script&lang=js"
export * from "./fastFreeShippingModel.vue?vue&type=script&lang=js"

import "./fastFreeShippingModel.vue?vue&type=style&index=0&id=7a5ed90a&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__